/**
 * Joint Management Module Translations - English
 * Includes: Joint Contract, Settlement
 */
export default {
  joint: {
    contract: {
      title: 'Joint Contract Management',
      // Search
      keyword: 'Keyword',
      keywordPlaceholder: 'Contract No/Merchant/Shop',
      contractNo: 'Contract No.',
      contractStatus: 'Contract Status',
      contractType: 'Contract Type',
      merchantName: 'Merchant Name',
      merchant: 'Merchant',
      allMerchants: 'All Merchants',
      shopName: 'Shop',
      brandName: 'Brand',
      settlementMode: 'Settlement Mode',
      contractPeriod: 'Contract Period',
      manualContractNo: 'Manual Contract No.',
      leaseArea: 'Lease Area',
      createTime: 'Create Time',
      operation: 'Operation',
      periodTo: 'to',
      unitYuan: 'CNY',
      unitSqm: 'sqm',
      unitPercent: '%',

      // Status
      statusDraft: 'Draft',
      statusPending: 'Pending Approval',
      statusEffective: 'Effective',
      statusExpired: 'Expired',
      statusTerminated: 'Terminated',

      // Contract Type
      typeNew: 'New',
      typeRenew: 'Renewal',
      typeChange: 'Change',

      // Settlement Mode
      modeCommission: 'Commission Rate',
      modeSalesGuarantee: 'Sales Guarantee',
      modeGrossProfit: 'Gross Profit Guarantee',

      // Actions
      addContract: 'New Contract',
      backToList: 'Back to List',
      search: 'Search',
      reset: 'Reset',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      approve: 'Approve',
      submitApproval: 'Submit Approval',
      withdrawApproval: 'Withdraw',
      renew: 'Renew',
      change: 'Change',
      terminate: 'Terminate',
      print: 'Print Contract',

      // Tabs
      tabBasic: 'Basic Info',
      tabSettlement: 'Settlement Standard',
      tabFee: 'Fee Info',
      tabTerms: 'Contract Terms',

      // Add/Edit page
      addTitle: 'New Joint Contract',
      editTitle: 'Edit Joint Contract',
      detailTitle: 'Joint Contract Detail',
      renewTitle: 'Renew Joint Contract',
      changeTitle: 'Change Joint Contract',

      // Basic Info - Contract Base
      sectionContractBase: 'Contract Base',
      signingDept: 'Signing Dept.',
      recruiter: 'Recruiter',
      signDate: 'Signing Date',
      signingDeptPlaceholder: 'Select department',
      deptRecruitment: 'Recruitment Dept.',
      deptOperation: 'Operation Dept.',
      deptMarketing: 'Marketing Dept.',

      // Basic Info - Merchant
      sectionMerchantInfo: 'Merchant Info',
      businessType: 'Business Type',
      salesDept: 'Sales Department',
      category: 'Business Category',
      categoryPlaceholder: 'Select business type first',
      businessTypeRetail: 'Retail',
      businessTypeCatering: 'Catering',
      businessTypeEntertainment: 'Entertainment',
      businessTypeService: 'Service',
      merchantRequired: 'Please select merchant',
      merchantPlaceholder: 'Select merchant',
      signingDeptRequired: 'Please select signing department',
      recruiterRequired: 'Please select recruiter',
      businessTypeRequired: 'Please select business type',
      categoryRequired: 'Please select business category',
      salesDeptRequired: 'Please select sales department',
      brandRequired: 'Please select at least one brand',
      signCompanyRequired: 'Please select billing entity',
      signDateRequired: 'Please select signing date',

      // Basic Info - Brand
      brandLabel: 'Brands',
      addBrand: '+ Add Brand',
      clickToSetMainBrand: 'Click brand name to set as main brand',
      mainBrand: 'Main Brand',

      // Basic Info - Shop
      sectionShopInfo: 'Shop Info',
      selectShop: 'Select Shop',
      addShop: '+ Add Shop',
      selectedShops: 'Selected Shops',
      totalArea: 'Total Area',
      selectedShopsCount: '{count} shops',
      shopRequired: 'Please select shop',

      // Basic Info - Billing Entity
      signCompany: 'Billing Entity',
      addCompany: '+ Add Company',

      // Basic Info - Contract Period
      sectionContractPeriod: 'Contract Period',
      startDate: 'Start Date',
      endDate: 'End Date',
      decorationStartDate: 'Decoration Start',
      decorationEndDate: 'Decoration End',
      openingDate: 'Opening Date',
      startDateRequired: 'Please select start date',
      endDateRequired: 'Please select end date',

      // Settlement Standard
      settlementModeLabel: 'Settlement Mode',
      defaultRate: 'Default Rate',
      periodBreakdown: 'Settlement Period',
      settlementPeriod: 'Settlement Period',
      mainRate: 'Main Rate(%)',
      rateColumn: 'Rate(%)',
      tierCount: 'Tier Count',
      guaranteeTierSales: 'Guarantee Sales {n}',
      guaranteeTierRate: 'Rate {n}(%',
      guaranteeTierGrossProfit: 'Guarantee GP {n}',
      tierAmountStart: 'Sales Amount From',
      tierAmountEnd: 'Sales Amount To',
      autoSplitYearly: 'Auto Split by Year',
      splitGuaranteeAmount: 'Split Guarantee Amount',
      addPeriod: 'Add Period',
      monthlyGuaranteeSales: 'Monthly Guarantee Sales',
      guaranteeRate: 'Guarantee Rate(%)',
      presetMonthlyGrossProfit: 'Preset Monthly Gross Profit',
      actualMonthlyGrossProfit: 'Actual Monthly Gross Profit',
      totalGuarantee: 'Total Guarantee',
      totalGrossProfit: 'Total Gross Profit',
      periodLabel: 'Period',
      monthlyBreakdown: 'Monthly Breakdown',
      yearMonthLabel: 'Year-Month',
      guaranteedSales: 'Guaranteed Sales',
      guaranteedGrossProfit: 'Guaranteed Gross Profit',
      periodSettled: 'Period Settled',
      cumulativeSettled: 'Cumulative Settled',
      rateSettings: 'Rate Settings',
      addRate: 'Add Rate',
      saveRates: 'Save Rates',
      allStages: 'All Stages',
      rateNamePlaceholder: 'e.g. Rate 1 - Main Brand',
      tierAmountPlaceholder: 'e.g. ≤500K',
      allAmount: 'Full Amount',
      ratePercent: 'Rate %',
      annualTotal: 'Total',
      yearStage: 'Year {n} ({start}~{end})',
      actualSales: 'Actual Sales',

      // Fee Info
      sectionPaymentFee: 'Payment Fee',
      sectionDeposit: 'Deposit',
      depositHint: '(Using existing deposit system)',
      depositType: 'Deposit Type',
      feeName: 'Fee Item',
      amount: 'Amount',
      receivedStatus: 'Received Status',
      received: 'Received',
      notReceived: 'Not Received',
      viewFlow: 'View Flow',
      addDeposit: 'Add Deposit',
      goToDeposit: 'Go to Deposit Management, auto-link current contract',
      sectionFeeItem: 'Fee Items',
      addFeeItem: 'Add Fee',
      feeItemHint: 'Fixed fees charged monthly/quarterly/yearly, e.g. promotion fee, operation mgmt fee, POS fee',
      chargeMethod: 'Charge Method',
      chargePeriod: 'Charge Period',
      startMonth: 'Start Month',
      endMonth: 'End Month',
      fixedAmount: 'Fixed Amount',
      salesRatioAmount: 'Sales Ratio',
      monthlyFixed: 'Monthly Fixed',
      dailyFixed: 'Daily Fixed',
      oneTimeFixed: 'One-time Fixed',
      monthlyPeriod: 'Monthly',
      quarterlyPeriod: 'Quarterly',
      yearlyPeriod: 'Yearly',
      oneTimePeriod: 'One-time',
      feeBearer: 'Fee Bearer',
      feeBearerMerchant: 'Merchant',
      feeBearerMall: 'Mall',
      feeHint: 'Payment processing fee deducted from merchant settlement',
      addPaymentMethod: 'Add Payment Method',
      savePaymentFees: 'Save Payment Fees',
      wechat: 'WeChat Pay',
      alipay: 'Alipay',
      bank: 'Bank Card',
      cash: 'Cash',
      selectPaymentMethod: 'Select payment method',
      feeRateLabel: 'Fee Rate',
      bearerLabel: 'Bearer',
      bearerRatioLabel: 'Bearer Ratio',
      feeNameRequired: 'Please select fee item',
      amountRequired: 'Please enter amount/ratio',
      startMonthRequired: 'Please select start month',
      editFeeItem: 'Edit Fee Item',
      newFeeItem: 'New Fee Item',
      feeItemPlaceholder: 'Select fee item',
      promotionFee: 'Promotion Fee',
      posFee: 'POS Fee',
      operationManagementFee: 'Operation Mgmt Fee',
      propertyManagementFee: 'Property Mgmt Fee',
      adFee: 'Ad Space Fee',
      other: 'Other',
      selectChargeMethod: 'Please select',
      amountPlaceholder: 'Enter amount or ratio',
      selectChargePeriod: 'Please select',
      endMonthPlaceholder: 'Empty = contract end',

      // Contract Terms
      specialTerms: 'Special Terms',
      specialTermsPlaceholder: 'Enter special terms',
      attachments: 'Attachments',
      attachment: 'Attachment',
      uploadAttachment: 'Upload Attachment',
      uploadTip: 'Common document/image formats, max 20MB per file, up to 10 attachments',
      noAttachment: 'No attachments',
      uploadSuccess: '{name} uploaded',
      uploadFailed: '{name} upload failed',
      fileSizeLimit: 'File size cannot exceed 20MB',
      fileCountLimit: 'Maximum 10 attachments',
      remark: 'Remark',
      remarkPlaceholder: 'Enter remark',

      // Settlement Settings (in Settlement Tab)
      settlementDay: 'Monthly Settlement Day',
      dayUnit: 'Day {n}',
      monthEnd: 'Month End',
      advanceSettlementDay: 'Advance Settlement',
      advanceSettlementDayPlaceholder: 'Select advance dates',
      feeBearerLabel: 'Fee Bearer',

      // Confirm Messages
      submitConfirm: 'Submit for approval? Contract info cannot be modified after submission.',
      withdrawConfirm: 'Withdraw the approval request for this contract?',
      deleteConfirm: 'Delete contract "{no}"?',
      renewConfirm: 'Create a renewal contract for "{no}"?',
      changeConfirm: 'Create a change contract for "{no}"?',
      terminateTitle: 'Terminate Contract',
      terminateReason: 'Termination Reason',
      terminateReasonRequired: 'Reason cannot be empty',
      terminateReasonPlaceholder: 'Enter termination reason...',
      terminateConfirm: 'Confirm Termination',

      // Success Messages
      submitSuccess: 'Submitted for approval',
      withdrawSuccess: 'Withdrawn successfully',
      deleteSuccess: 'Deleted successfully',
      renewSuccess: 'Renewal contract created',
      changeSuccess: 'Change contract created',
      terminateSuccess: 'Contract terminated',
      saveSuccess: 'Saved successfully',
      loadDetailFailed: 'Failed to load contract detail',
      generateSuccess: 'Settlement generated successfully',
      generateFailed: 'Generation failed',

      generateMonthly: 'Generate Settlement',
      selectMonth: 'Select Month',
      monthRequired: 'Please select settlement month',
    },

    settlement: {
      title: 'Joint Settlement',
      settlementNo: 'Settlement No.',
      settlementMonth: 'Settlement Month',
      merchantName: 'Merchant Name',
      shopNames: 'Shop',
      totalSales: 'Total Sales',
      appliedRate: 'Applied Rate',
      guaranteeAmount: 'Guarantee Amount',
      guaranteeMet: 'Guarantee Met',
      guaranteeMetYes: 'Met',
      guaranteeMetNo: 'Not Met',
      totalCommission: 'Total Commission',
      payableAmount: 'Payable Amount',
      status: 'Status',
      statusDraft: 'Draft',
      statusConfirmed: 'Confirmed',
      statusSettled: 'Settled',
      statusPaid: 'Paid',
      generateMonthly: 'Generate Monthly Settlement',
      inputSales: 'Input Sales Data',
      detail: 'Detail',
      confirm: 'Confirm',
      settle: 'Settle',
      pay: 'Pay',
      selectMonth: 'Select Month',
      selectContract: 'Select Contract',
      allContracts: 'All Contracts (select none for all)',

      // Detail
      detailTitle: 'Settlement Detail',
      contractNo: 'Contract No.',
      createTime: 'Create Time',
      payTime: 'Pay Time',
      salesDetail: 'Sales Detail',
      paymentMethod: 'Payment Method',
      salesAmount: 'Sales Amount',
      salesRatio: 'Ratio',
      feeRate: 'Fee Rate',
      feeAmount: 'Fee Amount',
      netSales: 'Net Sales',
      total: 'Total',
      calcTitle: 'Commission Calculation',
      guaranteeSales: 'Guarantee Sales',
      actualSales: 'Actual Sales',
      isMet: 'Target Met',
      metYes: 'Yes',
      metNo: 'No',
      metFormula: 'Actual Sales >= Guarantee Sales',
      baseCommission: 'Base Commission',
      excessSales: 'Excess Sales',
      excessRate: 'Excess Rate',
      excessCommission: 'Excess Commission',
      totalCommissionLabel: 'Total Commission',
      feeDeduction: 'Fee Deduction',
      adjustAmount: 'Adjust Amount',
      adjustRemark: 'Adjust Remark',
      adjustReason: 'Manual Adjustment',
      payableMerchant: 'Payable to Merchant',
      formulaBase: 'Total Commission - Fees + Adjustment',
      settleAction: 'Settle Action',
      adjustAmountLabel: 'Adjust Amount',
      adjustRemarkLabel: 'Adjust Remark',
      adjustRemarkPlaceholder: 'Enter adjustment reason',
      confirmPay: 'Confirm Payment',
      paymentVoucher: 'Payment Voucher',
      paymentVoucherRequired: 'Please enter payment voucher',
      paymentVoucherPlaceholder: 'Enter voucher number or remark',
      confirmPaySuccess: 'Payment confirmed',
      payFailed: 'Payment confirmation failed',
      close: 'Close',
      executeSettle: 'Execute Settlement',
      settleSuccess: 'Settlement completed',
      settleFailed: 'Settlement failed',
      confirmSuccess: 'Confirmed successfully',
      confirmFailed: 'Confirmation failed',
      confirmHint: 'Confirm this settlement? You can settle after confirmation.',
      confirmTitle: 'Confirm',
      settleHint: 'Execute settlement? Final payable amount will be calculated.',
      settleTitle: 'Settlement',
      loadDetailFailed: 'Failed to load settlement detail',
      salesShortfall: 'Sales Shortfall',

      // Product sales detail
      productSalesDetail: 'Product Sales Detail',
      productCode: 'Product Code',
      productName: 'Product Name',
      salesDept: 'Sales Dept',
      salesQuantity: 'Qty',
      salesAmountLabel: 'Sales Amt',
      discountAmount: 'Discount',
      couponAmount: 'Coupon',
      commissionRate: 'Rate(%)',
      taxedSettlement: 'Taxed Settlement Amt',
      taxRate: 'Tax(%)',
      taxAmount: 'Tax Amt',
      untaxedSettlement: 'Untaxed Settlement Amt',

      // Fee detail
      feeDetail: 'Fee Detail',
      feeItemName: 'Fee Name',
      feeAttribute: 'Attribute',
      feeAttributeCost: 'Cost',
      feeAttributeFee: 'Fee',
      collectionMethod: 'Collection',
      collectionMethodDeduct: 'Deduct',
      collectionMethodCash: 'Cash',
      feeAmountLabel: 'Fee Amt',
      affectsPayable: 'Affects Payable',

      // Summary
      amountSummary: 'Amount Summary',
      summaryBar: 'Summary',
      totalGuarantee: 'Guarantee',
      totalCommissionAmount: 'Commission',
      totalFeeAmount: 'Total Fees',
      deductFeeAmount: 'Fees (Deduct)',
      cashFeeAmount: 'Fees (Cash)',
      totalPayable: 'Total Payable',
      merchantInvoiceAmount: 'Merchant Invoice',
      mallInvoiceAmount: 'Mall Invoice',
      cashPaymentTotal: 'Cash Payment',
      noProductData: 'No product sales data',
      noFeeData: 'No fee data',
      basicInfo: 'Basic Info',
      print: 'Print',
      settlementPeriod: 'Period',

      // Sales Input
      inputSalesTitle: 'Input Sales Data',
      selectContract: 'Select Contract',
      contractRequired: 'Please select contract',
      yearMonth: 'Year-Month',
      yearMonthRequired: 'Please select month',
      cashSales: 'Cash Sales',
      wechatSales: 'WeChat Sales',
      alipaySales: 'Alipay Sales',
      bankSales: 'Bank Card Sales',
      otherSales: 'Other Sales',
      totalSalesLabel: 'Total Sales',
      inputSuccess: 'Sales data submitted',
      inputFailed: 'Submission failed',
      remarkLabel: 'Remark',
      remarkPlaceholder: 'Remark',
      submit: 'Submit',

      // List page extended fields
      totalSalesAmount: 'Total Sales',
      guaranteeMetYes: 'Met',
      guaranteeMetNo: 'Not Met',
      monthRequired: 'Please select settlement month',
      generateSuccess: 'Settlement generated successfully',
      generateFailed: 'Generation failed',
    }
  }
}
